"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTime = exports.formatTimeDate = exports.formatDate = void 0;
const formatDate = (date) => {
    if (date)
        return date.toLocaleDateString("cs-CZ");
    else
        return "—";
};
exports.formatDate = formatDate;
const formatTimeDate = (date) => {
    if (date)
        return (0, exports.formatDate)(date) + " " + (0, exports.formatTime)(date);
    //return date.toLocaleString();//toLocaleDateString("cs-CZ");
    else
        return "—";
};
exports.formatTimeDate = formatTimeDate;
const formatTime = (date) => {
    if (date)
        return date.getHours().toString().padStart(2, '0') + ":" + date.getMinutes().toString().padStart(2, '0');
    else
        return "—";
};
exports.formatTime = formatTime;
